export default {"src":"/_next/static/media/mma.17ac5f62.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};